const prod = {
  baseURL: `https://api.sharpvest.pro/api/v1`,
  apiURL: `https://api.sharpvest.pro`,
};

const dev = {
  baseURL: `https://api.sharpvest.pro/api/v1`,
  apiURL: `https://api.sharpvest.pro`,
};

export const config = process.env.NODE_ENV === `development` ? dev : prod;
